export const FINANCE_CHILD_ROUTES = [
  '/finance/petty-cash',
  '/finance/petty-cash/new',
  '/finance/petty-cash/funds',
  '/finance/petty-cash/reports',
  '/finance/petty-cash/reports/monthly',
  '/finance/corporate-expenses',
  '/finance/corporate-expenses/new',
  '/finance/company-assets',
  '/finance/company-assets/new',
  '/finance/coa',
  '/finance/exchange-rates',
];

function pushSection(items, title, links) {
  const visible = links.filter(Boolean);
  if (visible.length === 0) return;
  items.push({ label: title, isHeader: true });
  items.push(...visible);
}

/**
 * Flat flyout links for Finance under Administration (company treasury & accounting).
 * Project budget governance (Master Budget, Budget Management) lives under Project.
 */
export function buildFinanceFlyoutItems(hasMenuAccess) {
  const items = [];

  pushSection(items, 'Petty Cash', [
    hasMenuAccess('/finance/petty-cash') ? { label: 'Petty Cash Dashboard', path: '/finance/petty-cash' } : null,
    hasMenuAccess('/finance/petty-cash/new') ? { label: 'New Petty Cash', path: '/finance/petty-cash/new' } : null,
    hasMenuAccess('/finance/petty-cash/funds') ? { label: 'Petty Cash Funds', path: '/finance/petty-cash/funds' } : null,
    hasMenuAccess('/finance/petty-cash/reports') ? { label: 'Petty Cash Reports', path: '/finance/petty-cash/reports' } : null,
    hasMenuAccess('/finance/petty-cash/reports/monthly')
      ? { label: 'Monthly Report', path: '/finance/petty-cash/reports/monthly' }
      : null,
  ]);

  pushSection(items, 'Corporate Expenses', [
    hasMenuAccess('/finance/corporate-expenses')
      ? { label: 'Expenses List', path: '/finance/corporate-expenses' }
      : null,
    hasMenuAccess('/finance/corporate-expenses/new')
      ? { label: 'New Expense', path: '/finance/corporate-expenses/new' }
      : null,
  ]);

  pushSection(items, 'Company assets', [
    hasMenuAccess('/finance/company-assets')
      ? { label: 'Company assets (recovery)', path: '/finance/company-assets' }
      : null,
    hasMenuAccess('/finance/company-assets/new')
      ? { label: 'New company asset', path: '/finance/company-assets/new' }
      : null,
  ]);

  pushSection(items, 'Accounting', [
    hasMenuAccess('/finance/coa') ? { label: 'Chart of Accounts', path: '/finance/coa' } : null,
    hasMenuAccess('/finance/exchange-rates') ? { label: 'Exchange Rates', path: '/finance/exchange-rates' } : null,
  ]);

  return items;
}

export function buildFinanceFlyoutLinkItems(items) {
  return items.filter((item) => item?.path && !item.isHeader);
}
